import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { SyncIntroModalBody } from './sync-intro-modal-body';
import { SyncSpaceModalBody } from './sync-space-modal-body';
import { SyncFlowFooter } from './sync-flow-footer';
import { FormattedMessage, injectIntl, defineMessages, intlShape } from 'react-intl';
import { InviteShareBtn } from '../../elements-buttons/invite-share-button';

const translationMessages = defineMessages({
  inviteShareBtnText: {
    id: 'hosting.host_referral_main.invite_share_btn_text',
    defaultMessage: 'Copy'
  }
});

const ModalIcalShareComponent = ({
  toggleModal,
  body = {},
  nextModal,
  previousModal,
  length,
  index = 0,
  showModal,
  ...props
}) => {
  const selectedSpaceId = get(props, 'calendar.selectedSpace');
  const selectedSpace = get(props, ['calendar', 'spaceById', selectedSpaceId], {});
  const exportId = get(props, 'whichModalCb.export_id', '')
  return (
    <BootstrapModal
      showModal={showModal}
      body={
        <div className="flex column">
          <h2><FormattedMessage id="hosting.calendar_main.share_calendar_modal_heading" defaultMessage="Share calendar" /></h2>
          <p><FormattedMessage id="hosting.calendar_main.share_calendar_modal_description" defaultMessage="Share your Peerspace calendar with other iCAL applications. Copy and paste this link into your external calendar to share your Peerspace booking data."/></p>
          <div className="margin-xxl-bottom">
            <div>{selectedSpace.title || ''}</div>
            <div className="text-small text-gray-dark margin-lg-bottom">{selectedSpace.street || ''}</div>
            <InviteShareBtn
              link={`/calendar/ical/${exportId}.ics`}
              minWidth="122px"
              title={props.intl.formatMessage(translationMessages.inviteShareBtnText)}
              actions={{
                click: () => {
                  analyticsIntegrations.calendarIcsShared(selectedSpaceId, props.SSOid, exportId);
                }
              }}
            />
          </div>
        </div>
      }
      bodyClass="sync-modal-body text-center"
      toggleModal={toggleModal}
    />
  );
};

export const ModalIcalShare = injectIntl(ModalIcalShareComponent);

ModalIcalShareComponent.propTypes = {
  toggleModal: PropTypes.func,
  showModal: PropTypes.bool,
  body: PropTypes.object,
  length: PropTypes.number,
  index: PropTypes.number,
  nextModal: PropTypes.string,
  previousModal: PropTypes.string
};
